import { LabelProps, LineStyle } from '@editor/interfaces/canvas'
import { LineMaterial } from 'three-stdlib'

export const DEFAULT_LABEL_CONFIG: Partial<LabelProps> = {
  visible: true,
  styles: {
    color: '#000',
    backgroundColor: '#88DF41',
    opacity: 1,
  },
}

export const DEFAULT_LINE_CONFIG = {
  style: LineStyle.Dashed,
  color: '#FFFFFF',
  thickness: 0.001,
}

export const DEFAULT_OUTLINE_CONFIG = {
  color: 'white',
  style: LineStyle.Solid,
  thickness: 0.001,
}

export const DEFAULT_LINE_MATERIAL = new LineMaterial({
  transparent: true,
  alphaToCoverage: true,
  worldUnits: true,
  depthTest: false,
  depthWrite: false,

  // default dash styles
  dashed: true,
  dashScale: 400,
  dashSize: 2,
  gapSize: 1.5,
})
